import { memo } from 'react';

import { SmartHome } from './SmartHome';
import { smartHomeScheme } from './internal/settings/smartHomeScheme';

export const BLOCK_ID = 'smart-home';

export const SmartHomeContainer = memo(function SmartHomeContainer() {
  return <SmartHome id={BLOCK_ID} scheme={smartHomeScheme} />;
});
